import {Model} from "./Model";

export class PracticeCategory extends Model {
    course_id;
    slug;
    name;
    description;
    position;
    image;
    questions;
    completed;
}